import { FC } from 'react';

export const UnlinkIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M9 15H7a4 4 0 0 1 0-8h2" />
    <path d="M15 9h2a4 4 0 0 1 0 8h-2" />
    <line x1="10" y1="12" x2="14" y2="12" />
    <line x1="3" y1="3" x2="21" y2="21" />
  </svg>
);
